import moment from 'moment'

class DateTimeHelper {
    static formatJSONDateTime(jsonDatetime: string | Date): string {
        return moment(jsonDatetime).format('HH:mm DD/MM-YYYY')
    }

    static convertJSONDateTime(jsonDatetime: string): Date {
        //Util.console(`convertJSONDateTime : ${jsonDatetime}`, FColor.blue, FColor.white, 100_000)
        //convertJSONDateTime : 2024-08-10T12:24:34.969594+02:00 for en kamp der står som 12:24 i UI'et

        return moment(jsonDatetime).toDate()
    }

    static convertDateToJsonDateTime(date: Date): string {
        return moment(date).toJSON()
    }
}

export { DateTimeHelper }
